export default "__VITE_ASSET__BCKzJqyw__"